module.exports = __webpack_public_path__ + "static/media/stofferingen-25.e47c2363.jpg";